<template lang="pug">
.gu24-login(@click="c", :title="`${$t('toCabinet')}`",
  :class="{ 'gu24-login_loading': loading, 'dark': theme === 'dark', 'white': theme !== 'dark' }")
  span.gu24-login__avatar
    template(v-if="theme === 'dark'")
      svg(width="22", height="22", viewBox="0 0 22 22", fill="none",
        xmlns="http://www.w3.org/2000/svg")
        path(:d="d1", :fill="active ? '#FFDE00' : '#4D4D4D'")
        path(:d="d2", :fill="loading ? '#4D4D4D' : '#151515'", fill-rule="evenodd",
          clip-rule="evenodd")
    template(v-else)
      svg(width="32", height="32", viewBox="0 0 22 22", fill="none",
        xmlns="http://www.w3.org/2000/svg")
        path(:d="d1", :fill="active ? color : '#E2E2E2'")
        path(:d="d2", :fill="loading ? '#E2E2E2' : '#FFFFFF'", fill-rule="evenodd",
          clip-rule="evenodd")
</template>

<script>
export default {
  name: 'LoginButton',
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: 'white',
    },
    color: {
      type: String,
      required: false,
      default: '#fc0',
    },
  },
  data: () => ({
    /* eslint-disable max-len */
    d1: 'M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z',
    d2: 'M19.27 18.2533C17.254 20.5501 14.2963 22 11 22C7.70313 22 4.74501 20.5496 2.72893 18.2521C2.77958 18.1778 2.83272 18.1051 2.88831 18.0339C3.46729 17.2925 4.27804 16.7665 5.19104 16.54L8.06397 15.821L8.32495 14.776C7.59088 14.0081 7.10972 13.0337 6.94605 11.984C6.71372 11.938 6.50175 11.8201 6.34021 11.6468C6.17868 11.4736 6.07574 11.254 6.04602 11.019L5.85804 9.51901C5.8254 9.25789 5.88516 8.99359 6.0271 8.772C6.16904 8.55041 6.38417 8.38554 6.63501 8.30601C6.58101 7.85301 6.49903 7.09002 6.49903 6.75302C6.49903 5.30402 6.92903 3.82002 10.129 3.75302C10.9786 3.22014 11.9701 2.95821 12.972 3.00201C13.5172 2.95234 14.0658 3.04556 14.564 3.27246C15.0621 3.49936 15.4926 3.85213 15.813 4.29602C16.0996 4.6201 16.2544 5.03974 16.247 5.47229C16.2395 5.90484 16.0704 6.31892 15.773 6.63301L15.4919 6.91402L15.423 8.32602C15.6587 8.41495 15.8577 8.58055 15.9879 8.7962C16.1181 9.01185 16.172 9.26501 16.141 9.51501L15.953 11.015C15.9251 11.2347 15.8332 11.4413 15.6886 11.609C15.544 11.7767 15.3532 11.8981 15.14 11.958C14.9756 13.0478 14.4671 14.0565 13.689 14.837L13.934 15.815L16.807 16.534C17.7199 16.7618 18.5302 17.2889 19.1084 18.0312C19.1648 18.1036 19.2187 18.1777 19.27 18.2533Z',
    /* eslint-enable max-len */
  }),
  methods: {
    c(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss">
.gu24-login {
  cursor: pointer;
  &__avatar {
    display: inline-block;
    border-radius: 50%;
    position: relative;
    vertical-align: middle;
  }
  svg {
    transition: all 0.25s ease;
    > * {
      transition: all 0.25s ease;
    }
  }
}

// --- WHITE THEME ---
.white.gu24-login {
  margin-left: 30 / 16 + rem;
  margin-right: -.325rem;
  @media screen and (max-width: 960px) {
    margin-left: unset;
  }
}
.white.gu24-login_loading .gu24-login__avatar {
  & svg {
    opacity: 0.4;
  }
  &:before {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: absolute;
    content: '';
    display: block;
    border: 2 / 16 + rem solid;
    border-color: rgba(0, 0, 0, 1);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: loader 1s infinite ease-in-out;
  }
}
.white .gu24-login__avatar {
  width: 32 / 16 + rem;
  height: 32 / 16 + rem;
}

// --- DARK THEME ---
.dark.gu24-login {
  float: left;
  padding: 19 / 16 + rem 10 / 16 + rem;
}
.dark .gu24-login__avatar {
  width: 22 / 16 + rem;
  height: 22 / 16 + rem;
}
.dark.gu24-login_loading .gu24-login__avatar {
  & svg {
    opacity: 0.4;
  }
  &:before {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: absolute;
    content: '';
    border: 2 / 16 + rem solid;
    border-color: rgba(255, 255, 255, 1);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: loader 1s infinite ease-in-out;
  }
}

@keyframes loader {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }
  100% {
    transform: translate(-50%, -50%) scale(2);
    border-color: rgba(255, 255, 255, 0.01);
  }
}
</style>
